<template>
  <span :class="validationClass">
    <el-input
      ref="editor"
      v-if="visible"
      v-model="value"
      size="mini"
      :edit="true"
      controls-position="right"
      @blur="endEdit();"
      @keyup.enter.native="endEdit();"
      @keyup.esc.native="cancelEdit();"
      @clearable="endEdit();"
      @input="checkValid"
    ></el-input>
    <!--
      <el-input-number ref="editor" v-if="visible" v-model="value" size="mini" :edit="true" controls-position="right"
      :clearable="clearable"
      :min="min"
      :max="max"
      @blur="endEdit()" @keyup.enter.native="endEdit()" @keyup.esc.native="cancelEdit()"
      @clearable="endEdit()" @input="checkValid"></el-input-number>
    -->
    <span v-else-if="$slots.content === undefined">
      {{getValueAfterCheckEmpty(data[property])}}
    </span>
    <slot name="content" v-else></slot>
  </span>
</template>

<script>
import isNil from 'lodash/isNil';
import { isNumber } from '@/utils/number';
import { matcher, getValueAfterCheckEmpty } from '@/utils/string';
import InputCellEditorMixin from './mixins/input-cell-editor';
// TODO: clearable 클릭 시 blur 호출되므로 일단 제거.
export default {
  name: 'WNumberEditor',
  props: {
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    precision: {
      type: Number,
    },
    integer: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [InputCellEditorMixin],
  methods: {
    getValueAfterCheckEmpty,
    isValid(value) {
      if (!this.required && (isNil(value) || value === '')) {
        return true;
      }
      return (this.required ? !isNil(value) && value !== '' : true) && this.validatorForNumber(value) && (this.validation ? this.validation(value) : true);
    },
    validatorForNumber(value) {
      return isNumber(value) && (this.integer ? matcher.integer().test(value) : true) && (this.min ? value >= this.min : true) && (this.max ? value <= this.max : true);
    },
    toPrecision(num, precision) {
      return parseFloat(parseFloat(Number(num).toFixed(precision)));
    },
    setCurrentValue(_value) {
      let value;
      if (typeof _value === 'number' && this.precision !== undefined) {
        value = this.toPrecision(_value, this.precision);
      } else {
        value = _value;
      }
      this.value = value;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/table/cell-editor/NumberEditor.vue